export default __webpack_public_path__ + "static/shutdown-banner-web-e447cdfb3005054348512bf046009d6d.png";